export const EXTENDED_PROFILE_VERSION = 1;

/** Sezioni modificabili singolarmente dalla tab Anagrafica */
export const EXTENDED_PROFILE_SECTION_IDS = [
    'contacts',
    'personal',
    'address',
    'identity',
    'health',
    'professional',
    'notes',
];

export function emptyExtendedProfile() {
    return {
        _v: EXTENDED_PROFILE_VERSION,
        contacts: {
            landline: '',
            secondary_email: '',
            emergency_contact: '',
            emergency_phone: '',
        },
        personal: {
            birth_date: '',
            gender: '',
            birth_place: '',
            birth_place_zip: '',
            citizenship: 'IT',
            fiscal_code: '',
        },
        address: {
            street: '',
            city: '',
            province: '',
            zip: '',
            country: 'IT',
            google_place_id: '',
        },
        identity: {
            document_type: '',
            document_number: '',
            document_issue_date: '',
            document_expiry: '',
        },
        health: {
            medical_certificate: '',
            medical_cert_expiry: '',
            insurance_number: '',
            insurance_expiry: '',
            attachments: '',
        },
        professional: {
            profession: '',
            company: '',
        },
    };
}

export function parseExtendedProfile(raw) {
    if (!raw) return emptyExtendedProfile();
    let data = raw;
    if (typeof raw === 'string') {
        try {
            data = JSON.parse(raw);
        } catch {
            return emptyExtendedProfile();
        }
    }
    if (!data || typeof data !== 'object') return emptyExtendedProfile();

    const base = emptyExtendedProfile();
    Object.keys(base).forEach((section) => {
        if (section === '_v') {
            base._v = data._v || EXTENDED_PROFILE_VERSION;
            return;
        }
        if (!data[section] || typeof data[section] !== 'object') return;
        Object.keys(base[section]).forEach((field) => {
            if (data[section][field] != null && data[section][field] !== '') {
                base[section][field] = String(data[section][field]);
            }
        });
        // Legacy: birth_place_code → birth_place_zip se erano salvati 5 cifre
        if (section === 'personal' && !base.personal.birth_place_zip && data.personal?.birth_place_code) {
            const legacy = String(data.personal.birth_place_code).replace(/\D/g, '');
            if (legacy.length === 5) base.personal.birth_place_zip = legacy;
        }
    });
    return base;
}

export function getProfileSection(member, section) {
    const profile = parseExtendedProfile(member?.extended_profile);
    return profile[section] || {};
}

const NATIONALITY_BY_CITIZENSHIP = {
    IT: 'Italiana',
    FR: 'Francese',
    DE: 'Tedesca',
    ES: 'Spagnola',
    GB: 'Britannica',
    US: 'Statunitense',
    CH: 'Svizzera',
    AT: 'Austriaca',
    BE: 'Belga',
    NL: 'Olandese',
    PT: 'Portoghese',
    GR: 'Greca',
    PL: 'Polacca',
    RO: 'Rumena',
    AL: 'Albanese',
    MA: 'Marocchina',
    TN: 'Tunisina',
    EG: 'Egiziana',
    RU: 'Russa',
    CN: 'Cinese',
    IN: 'Indiana',
    BR: 'Brasiliana',
    AR: 'Argentina',
};

export function deriveNationality(citizenshipCode) {
    if (!citizenshipCode || String(citizenshipCode).trim() === '') return '';
    const code = String(citizenshipCode).trim().toUpperCase().slice(0, 2);
    if (NATIONALITY_BY_CITIZENSHIP[code]) return NATIONALITY_BY_CITIZENSHIP[code];
    try {
        const dn = new Intl.DisplayNames(['it'], { type: 'region' });
        return dn.of(code) || code;
    } catch {
        return code;
    }
}

export const COUNTRY_OPTIONS = [
    { code: 'IT', label: 'Italia' },
    { code: 'FR', label: 'Francia' },
    { code: 'DE', label: 'Germania' },
    { code: 'ES', label: 'Spagna' },
    { code: 'GB', label: 'Regno Unito' },
    { code: 'US', label: 'Stati Uniti' },
    { code: 'CH', label: 'Svizzera' },
    { code: 'AT', label: 'Austria' },
    { code: 'BE', label: 'Belgio' },
    { code: 'NL', label: 'Paesi Bassi' },
    { code: 'PT', label: 'Portogallo' },
    { code: 'GR', label: 'Grecia' },
    { code: 'PL', label: 'Polonia' },
    { code: 'RO', label: 'Romania' },
    { code: 'AL', label: 'Albania' },
    { code: 'MA', label: 'Marocco' },
    { code: 'TN', label: 'Tunisia' },
    { code: 'EG', label: 'Egitto' },
    { code: 'RU', label: 'Russia' },
    { code: 'CN', label: 'Cina' },
    { code: 'IN', label: 'India' },
    { code: 'BR', label: 'Brasile' },
    { code: 'AR', label: 'Argentina' },
];

export const GENDER_OPTIONS = [
    { value: 'M', label: 'Maschio' },
    { value: 'F', label: 'Femmina' },
];

export const DOCUMENT_TYPE_OPTIONS = [
    { value: 'CI', label: 'Carta d\'identità' },
    { value: 'PASSPORT', label: 'Passaporto' },
    { value: 'PATENTE', label: 'Patente' },
];

export function formatProfileDate(value) {
    if (!value) return null;
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleDateString('it-IT');
}

export function displayValue(value) {
    if (value === null || value === undefined || String(value).trim() === '') return null;
    return String(value);
}
